import(/* webpackMode: "eager" */ "/opt/buildhome/repo/landing/src/app/error.jsx");
